import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { Provider } from "react-redux";
import { theme } from "./theme";
import { GlobalStyle } from "./GlobalStyle";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById('root')!); // dodając wykrzyknik zapewniamy, że to nie jest null i typeScript już nie uważa tego za błąd
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();